/**
 * @file Ask
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'


class Email extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (
            <div id="email">
                <div className="notice">填写完毕后，请发送至邮箱sc@ihatoo.com ，工作人员将在 2-3个工作日联系您</div>
            </div>

        )
    }
}

export default Email
